import { useAuthControllerValidateEmailCode } from '@/api/generated/okami.ts'
import { Button } from '@/components/ui/button.tsx'
import { createFileRoute } from '@tanstack/react-router'
import { CheckCircle, Loader2, XCircle } from 'lucide-react'
import { useCallback, useEffect } from 'react'

export const Route = createFileRoute('/auth/confirm-email/$code')({
  component: ConfirmEmail,
  head: () => ({
    meta: [
      {
        title: 'Confirmar E-mail | Okami',
      },
    ],
  }),
})

function ConfirmEmail() {
  const { code } = Route.useParams()

  const { mutateAsync, isPending, isSuccess, isError } = useAuthControllerValidateEmailCode({
    mutation: {
      mutationKey: ['validate-email-code', { code }],
      meta: {
        errorMessage: 'Erro ao confirmar e-mail',
      },
      scope: {
        id: code,
      },
    },
  })

  const handleValidateEmailCode = useCallback(async () => {
    if (isPending || !code) return

    await mutateAsync({ data: { code } })
  }, [mutateAsync])

  useEffect(() => {
    void handleValidateEmailCode()
  }, [])

  if (isPending) {
    return (
      <div className="p-8">
        <div className="flex w-[320px] flex-col justify-center gap-6 items-center">
          <Loader2 className="mr-2 size-10 animate-spin" />
        </div>
      </div>
    )
  }

  if (isSuccess) {
    return (
      <div className="p-8">
        <div className="flex w-[320px] flex-col justify-center gap-6 items-center">
          <CheckCircle className="size-14 text-emerald-500" />
          <p className="text-foreground text-lg text-center">
            E-email confirmado, vocẽ já pode fechar essa aba !
          </p>
        </div>
      </div>
    )
  }

  if (isError) {
    return (
      <div className="p-8">
        <div className="flex w-[320px] flex-col justify-center gap-6 items-center">
          <XCircle className="size-16 text-red-700" />
          <p className="text-muted-foreground text-md text-center">Houve erro ao validar o e-mail</p>
          <Button variant="ghost" onClick={handleValidateEmailCode}>
            Tentar novamente
          </Button>
        </div>
      </div>
    )
  }

  return <></>
}
